import AttachmentActionTypes from "attachment/attachment-action-types"

export const editAttachment = (key, value) =>
    ({ type: AttachmentActionTypes.EDIT_ATTACHMENT, key, value })
